export enum QuestionsPermission {
  FullAccessManager = 'full_access_manager',
  ViewOnlyManager = 'view_only_manager',
  Submitter = 'submitter',
  None = 'none',
}

export const questionManagePGList = [
  QuestionsPermission.FullAccessManager,
  QuestionsPermission.ViewOnlyManager,
];
export const questionAccessPGList = [
  ...questionManagePGList,
  QuestionsPermission.Submitter,
];
